var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00006C7.58172 4.00006 4 7.58178 4 12.0001C4 16.4183 7.58172 20.0001 12 20.0001C16.4183 20.0001 20 16.4183 20 12.0001C20 7.58178 16.4183 4.00006 12 4.00006ZM2 12.0001C2 6.47721 6.47715 2.00006 12 2.00006C17.5228 2.00006 22 6.47721 22 12.0001C22 17.5229 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.5229 2 12.0001ZM12 6.00006C12.5523 6.00006 13 6.44778 13 7.00006L13 11.5858L15.7071 14.293C16.0976 14.6835 16.0976 15.3166 15.7071 15.7072C15.3166 16.0977 14.6834 16.0977 14.2929 15.7072L11.2929 12.7072C11.1054 12.5196 11 12.2653 11 12.0001L11 7.00006C11 6.44778 11.4477 6.00006 12 6.00006Z",
    fill: "#FFC500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockLight);
export default __webpack_public_path__ + "static/media/clock-light.766dcb83f3518e2d73d6c048e36f9024.svg";
export { ForwardRef as ReactComponent };